// mockTest/data/columns.ts
import { TFunction } from 'i18next';

export const getFullTestColumns = (t: TFunction) => [
  {
    title: t('page.mockTest.intro.part'),
    dataIndex: 'part',
    render: (_: string, __: any, index: number) => {
      if (index === 2 || index === 4) {
        return {
          children: (
            <span className="block text-center">
              <strong>{t('page.mockTest.intro.break')}</strong> ({t('page.mockTest.intro.notInclude')})
            </span>
          ),
          props: { colSpan: 2 },
        };
      }
      return <>{_}</>;
    },
  },
  {
    title: t('page.mockTest.intro.content'),
    dataIndex: 'content',
    render: (_: string, __: any, index: number) => {
      if (index === 2 || index === 4) {
        return { props: { colSpan: 0 } };
      }
      return <>{_}</>;
    },
  },
  {
    title: t('page.mockTest.intro.timeAllowed'),
    dataIndex: 'time',
  },
];

export const getSectionTestColumns = (t: TFunction, rowSpanCount: number) => [
  {
    title: t('page.mockTest.intro.part'),
    dataIndex: 'part',
    render: (text: string, _: any, index: number) => renderRowSpan(text, index, rowSpanCount),
  },
  {
    title: t('page.mockTest.intro.content'),
    dataIndex: 'content',
    render: (text: string) => <>{text}</>,
  },
  {
    title: t('page.mockTest.intro.timeAllowed'),
    dataIndex: 'time',
    render: (text: string, _: any, index: number) => renderRowSpan(text, index, rowSpanCount),
  },
];

const renderRowSpan = (text: string, index: number, rowSpanCount: number) => {
  return index === 0
    ? { children: <>{text}</>, props: { rowSpan: rowSpanCount } }
    : { children: null, props: { rowSpan: 0 } };
};
